@if (selectOptionLabel?.template || ss.selectLabel || selectContentLabel?.template; as label) {
  <select-item
    class="z-fx-flex"
    [selected]="selected"
    [prefix]="prefix"
    [label]="label"
    [value]="value"
    [radioType]="radioType"
    [isMultiSelect]="ss.isMultiSelect$ | async"
    [disabled]="disabled$ | async"
  ></select-item>
}

<ng-container *selectLabel>{{ viewValue }}</ng-container>

@if (!viewValue) {
  <div #viewValueContent>
    <ng-content></ng-content>
  </div>
}
